Vue.component('vq-file-zone', {
  delimiters: ['[[', ']]'],
  props: {
    label: String,
    labelClasses: String,
    model: Array,
    name: String,
    maxFiles: {
      type: Number,
      default: 1,
    },
    mandatory: {
      type: Boolean,
      default: false,
    }
  },
  data: () => {
    return {
      isError: false,
      isErrorNbFilesMax: false,
      content: {
        'browse_button': gettext('parcourir'),
        'accepted_files': gettext('Fichiers acceptés'),
        'single_file': gettext('votre fichier'),
        'multi_file': gettext('vos fichiers'),
        'no_file': gettext('aucun fichier'),
        'error_message': gettext("Le format attendu ou la taille max ne sont pas respectés. Merci de choisir un fichier correct."),
        'error_message_max': gettext("Vous dépassez le nombre de fichiers autorisés.")
      }
    }
  },
  methods: {
    change(event) {
      let files = event.target.files;
      if ((files.length + this.model.length) <= this.maxFiles) {
        console.log("Nb de fichiers OK");
        Array.from(files).forEach((file, index) => {
          if (['image/jpeg', 'image/png', 'application/pdf'].includes(file.type) && file.size <= 5242880) {
            if (index === Array.from(files).length - 1) {
              this.$emit('newfiles', files);
            }
          }
          else {
            this.isError = true;
            setTimeout(() => {
              this.isError = false;
            }, 4000);
          }
        })
      } else {
        console.log("NOK");
        this.isError = true;
        this.isErrorNbFilesMax = true;
        setTimeout(() => {
          this.isError = false;
        }, 4000);
      }
    },
    deleteFile(id) {
      this.$emit('deletefile', id);
    },
    resetInput() {
      this.$refs.inputFile.value = '';
    }
  },
  template: `<div class="form-control">
	<span class="label pb-5" :class="labelClasses" v-if="label">[[label]]</span>
	<div class="row">
		<div class="flex-row items-center flex-wrap" :class="maxFiles > 1 ? 'col-md-12' : 'col-md-6'">
			<div class="wrapper">
				<input class="hide" ref="inputFile" @change="change($event)" @click="resetInput()" type="file"
					:name="name" :id="name" accept=".pdf, .jpg, .png" :multiple="maxFiles > 1">
				<label class="btn is-primary is-medium is-uppercase justify-center" :for="name">
					[[content.browse_button]]
				</label>
			</div>
			<div class="pl-20-sm pt-10 pt-n-sm">
				<p><span class="c-primary">[[content.accepted_files]]</span> : jpeg,png,pdf</p>
				<p>5 Mo/Max</p>
			</div>
		</div>
		<div :class="maxFiles > 1 ? 'col-md-12' : 'col-md-6'">
			<div class="row file-zone mh-n bg-white" :class="{ 'mt-40' : maxFiles > 1 }">
				<div class="pv-20 ph-20 text-center" :class="maxFiles > 1 ? 'col-md-3 col-lg-2' : 'col-md-6'">
					<span class="block c-gray-800 uppercase fw-bold" v-if="maxFiles > 1">[[content.multi_file]]<span
							v-if="mandatory"> *</span></span>
					<span class="block c-gray-800 uppercase fw-bold" v-if="maxFiles == 1">[[content.single_file]]</span>
					<span class="block c-primary pt-5">[[maxFiles]] maximum</span>
				</div>
				<div class="mv-a ph-30 files-container" :class="maxFiles > 1 ? 'col-md-9 col-lg-10' : 'col-md-6'">
					<p class="capitalize text-center pv-20 text-center full-w" v-if="model.length == 0"
						:class="maxFiles > 1 ? 'fs-22' : 'fs-18'">[[content.no_file]]</p>
					<div class="row full-w" v-if="model.length > 0">
						<div v-for="(file, index) in model" class="pv-10 card--file"
							:class="maxFiles > 1 ? 'col-md-3' : 'col-md-12'" :key="index">
							<a :href="file.file" target="_blank" class="image">
								<i class="icon icon-file"></i>
								<span class="uppercase block">[[file.document_type_display]]</span>
							</a>
							<div class="content pl-10">
								<span class="c-gray-800 fw-medium fs-12 block word-break">[[file.filename]]</span>
								<span class="c-gray-500 fw-medium fs-12 block pv-5">[[file.file_size]]</span>
								<button type="button" @click="deleteFile(file.id)">
									<i class="icon icon-close"></i>
								</button>
							</div>

						</div>
					</div>
				</div>
				<div class="error" v-if="isError">
					<p class="text-center pv-20 text-center full-w" v-if="!isErrorNbFilesMax">[[content.error_message]]
					</p>
					<p class="text-center pv-20 text-center full-w" v-else>[[content.error_message_max]]
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
`
})
